<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h2 class="mb-4">Divisions Organogram</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="div in divisions" :key="div._id" cols="12" sm="6" md="4" lg="3" class="d-flex">
        <v-card class="elevation-2 pa-2 mx-auto d-flex flex-column" width="100%" max-width="280">
          <v-card-title class="pb-6 font-weight-regular" style="word-break: break-word;">{{ div.divisiontName || div.name }}</v-card-title>
          <v-spacer></v-spacer>
          <v-card-actions class="justify-center px-4">
            <v-btn color="success" outlined block small @click="viewOrganogram(div._id)">
              VIEW
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TeamList',
  data() {
    return {
      divisions: []
    };
  },
  async created() {
    await this.fetchDivisions();
  },
  methods: {
    async fetchDivisions() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('/division-organogram/divisions', {
          headers: { 'x-auth-token': token }
        });
        if (res.data && res.data.status) {
          this.divisions = res.data.data;
        }
      } catch (e) {
        console.error("Error fetching divisions:", e);
      }
    },
    viewOrganogram(id) {
      this.$router.push({ path: `/admin/teams/organogram/${id}` });
    }
  }
};
</script>
